import { REGION_SNAP_RANGE } from 'lib/constants';

export const expandRect = (rect, margin) => {
  return {
    top: rect.top - margin,
    left: rect.left - margin,
    bottom: rect.bottom + margin,
    right: rect.right + margin,
  };
};

export const edgeIsNear = (edge1, edge2, margin=REGION_SNAP_RANGE) => {
  return edge1 <= edge2 + margin && edge1 >= edge2 - margin;
};

export const verticalIntersection = (dragging, target) => {
  return (dragging.top < target.bottom && dragging.top > target.top)
  || ( dragging.bottom > target.top && dragging.bottom < target.bottom );
};

export const horizontalIntersection = (dragging, target) => {
  return (dragging.left < target.right && dragging.left > target.left)
  || ( dragging.right > target.left && dragging.right < target.right );
};



// WEBPACK FOOTER //
// ./starling/src/lib/rect.js